/**
 * The table panel type and the columns block it draws from.
 */
import { ANALYTICS_COLUMN_TYPES, normalizeAnalyticsColumnType } from '../../../cirra/analyticsColumnTypes.js';

const columns = {
  names: [{ id: 'table', label: 'Table', phrase: 'a table', guide: 'table.md', advanced: true, promptSummary: 'rows and columns' }],
  block: 'columns',
  /* The gestures this renderer FIRES (analyticsPanelEvents.js). Declared per type because an event
     a renderer never fires is a wiring that silently does nothing — so a type claims one only once
     its renderer calls the action hook. */
  events: ['rowClick'],
  /* Not one type's settings — the tool declares it by hand beside the properties every panel
     carries, and the surfaces that walk one block per type leave it out and reach for it by name.
     That is all `sharedBlock` says here. It is also why this spec is not the last word on what a
     stored columns block holds: the visual editor writes a `mode` the agent never sends.

     WHO MAY BE WRITTEN one is a separate question, and the answer is `carriedBy` like every other
     block. Only the table renderer reads `display.columns`; on any other type the block stores
     settings nothing draws. It read as the formatting surface for every panel precisely because it
     was the one block that accepted a write from anywhere — asked to show a chart's values as
     money, an agent set a currency column here, was told it saved, and the chart went on printing
     raw decimals (2026-08-17). A leftover block from the type a panel used to be is untouched, as
     with any carried block; only an explicit write is refused. */
  sharedBlock: true,
  carriedBy: ['table'],
  /* Displayed columns. `keys` is a full replacement list, so an empty one means "no custom columns"
     rather than no opinion — hence not required.

     The type vocabulary comes from shared/cirra so this writer and cirra's columns editor validate
     against the same list: the tool only ever sends "html", but the reconciler infers date/number/
     list types, and a writer holding a narrower private list silently destroys the ones it does not
     recognize. A type outside the shared vocabulary keeps whatever is stored, like any other enum. */
  /* `width` is the authored width in pixels — the page's own answer for every viewer, between the
     content measure and a viewer's own drag. Declared here because the list merge keeps only the
     item fields it is told about (mergeAnalyticsConfigBlock's mergeList), so a width left out of
     this spec would be erased by the next agent edit that touched columns for any reason. Clearable
     because '' is how a caller says "back to auto"; the range is enforced where the width is read,
     since a stored config is tolerated and clamped rather than rejected.

     `label` and `tooltip` belong to a `button` column (the one type whose cell is a control, not a
     value) — declared for the same merge-survival reason as width, and clearable. The label is the
     short verb ON the button; the tooltip is the sentence of detail shown on hover, which is what
     lets the label stay short. Meaningless on value columns, whose header already labels them. */
  fields: {
    keys: { kind: 'list', keyField: 'key', item: { type: { kind: 'enum', values: ANALYTICS_COLUMN_TYPES, normalize: normalizeAnalyticsColumnType }, width: { kind: 'number', clearable: true }, label: { kind: 'text', clearable: true }, tooltip: { kind: 'text', clearable: true } } }
  }
};

export default columns;
